import React from "react";
import { Typography } from "antd";
import RolesStatusTag from "./RolesStatusTag";
import { formatISODateToMMDDYYYY } from "@/utils/dateUtils";
import { RoleKey } from "./rolesConfig";
const { Text } = Typography;

export type RoleProps = {
  roles: RoleKey[];
  name: string;
  email: string;
  creation_date: string | null;
  deactivation_date: string | null;
  company: string | null;
};

type RolesCardProps = {
  user: RoleProps;
};

const FALLBACK_TEXT = "Unknown";

const renderDate = (date: string | null) => {
  if (!date) return "-";
  const formatted = formatISODateToMMDDYYYY(date);
  return formatted === "Invalid Date" ? "-" : formatted;
};

export default function RolesCard({ user }: RolesCardProps) {
  return (
    <div className="grid grid-cols-[1fr_2fr_2.5fr_1fr_1fr_0.9fr] gap-4 items-center mb-3 bg-white p-4 rounded-sm">
      <div className="flex flex-col gap-2">
        {user?.roles?.length > 0 ? (
          user.roles.map((role) => {
            return <RolesStatusTag key={role} role={role} />;
          })
        ) : (
          <RolesStatusTag />
        )}
      </div>

      <Text ellipsis={{ tooltip: user.name }}>
        {user.name || FALLBACK_TEXT}
      </Text>
      <Text ellipsis={{ tooltip: user.email }}>
        {user.email || FALLBACK_TEXT}
      </Text>
      <p>{renderDate(user.creation_date)}</p>
      <p>{renderDate(user.deactivation_date)}</p>
      <Text ellipsis={{ tooltip: user.company }}>
        {user.company || FALLBACK_TEXT}
      </Text>
    </div>
  );
}
